module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_03-207a1f3a7dadfa79fd8fd422cea6fcbf.png";